Vue.component('panel-key-replace', {
	props: ["options", "labellang"],
	template: 
		'<transition v-if="isActive" name="bounce" enter-active-class="bounceInUp" leave-active-class="bounceOutDown" v-bind:css="options.internal.isAnimationCompatibility">' +
		'	<div id="panel-key-replace" class="panel-widget">' +
		'		<div class="overlay-content text-center">' +
		'			<h3>{{ title }}</h3>' +
		'			<div class="input-group">' +
		'				<input id="passwordField" v-model="password" @keyup.enter="sendWidget" type="password" class="form-control" />' +
		'				<span class="input-group-addon">' +
		'					<i class="material-icons">vpn_key</i>' +
		'				</span>' +
		'			</div>' +
		'		</div>' +
		'		<div class="overlay-footer">' +
		'			<button v-if="btCancelVisible" @click="closeView" class="btn pull-left" > {{ cancel }} </button>' +
		'			<button @click="sendWidget" class="btn btn-info pull-right"  data-language="send" >{{ send }}</button>' +
		'		</div>' +
		'		</div>' +
		'	</div>' +
		'</transition>',
	data: function () {
		return {
			isActive: false,
			title: this.labellang.title_password || "Insert your password",
			send: this.labellang.webcb_send_button,
			cancel: this.labellang.cancel,
			btCancelVisible: false,
			password:null,
			characterCircle:'&#9679;'		}
	},
	mounted: function () {
		var that = this;
		bus.$on('onShowPanelKeyReplace', function (val) {
			that.contentShow(val);
		})

	},
	methods: {
		contentShow: function (val) {
			this.isActive = val;
			if (this.isActive) {
				setTimeout(function() {
					document.getElementById("passwordField").focus();
				},1100);//<-- questo timeout deve essere superiore a quello del metodo disable del footer per le emoji
			}
		},
		closeView: function () {
			this.isActive = false;
			// bus.$emit("onInputMsgDisabled", false);
		},
		convertMsg:function(msg){
			return msg.replace(/./g, this.characterCircle);
		},
		sendWidget: function () {
			if(this.password && this.isActive) {
			  this.password = this.password.replace(/</g,"&#x3C;").replace(/>/g,"&#x3E;"); //per evitare injection dal campo password
				this.options.internal.bridge.sendChatMessage(this.password);
				bus.$emit("onKeyReplace", this.convertMsg(this.password) );
				this.isActive = false;
				this.password = null;
			}
			bus.$emit("onCloseWidget");
		}
	}
})
